const ready = require('./utilities').ready;

const GSI_SCRIPT_SELECTOR = 'script[src*="accounts.google.com/gsi/client"]';
const INIT_TIMEOUT_MS = 10000;
const POLL_INTERVAL_MS = 100;

ready(init);

function init() {
  const el = document.getElementById('google-one-tap');
  if (!el) return;
  if (document.body.dataset.userSignedIn === 'true') return;

  waitForGoogleIdentity(() => {
    const loginUri = buildLoginUri(el.dataset.loginUri, el.dataset.followGuruId);

    window.google.accounts.id.initialize({
      client_id: el.dataset.clientId,
      callback: (response) => submitCredential(response?.credential, loginUri),
      itp_support: true,
    });

    // FedCM does not support isNotDisplayed() / isSkippedMoment(). prompt()
    // with no moment listener is the supported One Tap entry point.
    window.google.accounts.id.prompt();
  });
}

function submitCredential(credential, loginUri) {
  if (!credential || !loginUri) return;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = loginUri;

  appendHidden(form, 'credential', credential);

  const railsCsrf = document.querySelector('meta[name="csrf-token"]')?.content;
  if (railsCsrf) appendHidden(form, 'authenticity_token', railsCsrf);

  const googleCsrf = readCookie('g_csrf_token');
  if (googleCsrf) appendHidden(form, 'g_csrf_token', googleCsrf);

  document.body.appendChild(form);
  form.submit();
}

function appendHidden(form, name, value) {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  form.appendChild(input);
}

function readCookie(name) {
  const prefix = `${name}=`;
  const parts = document.cookie.split(';');
  for (let i = 0; i < parts.length; i += 1) {
    const trimmed = parts[i].trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return null;
}

function buildLoginUri(loginUri, followGuruId) {
  if (!followGuruId) return loginUri;

  const separator = loginUri.includes('?') ? '&' : '?';
  return `${loginUri}${separator}follow_guru_id=${encodeURIComponent(followGuruId)}`;
}

function waitForGoogleIdentity(callback) {
  if (window.google?.accounts?.id) {
    callback();
    return;
  }

  if (!document.querySelector(GSI_SCRIPT_SELECTOR)) {
    return;
  }

  const startedAt = Date.now();
  const interval = setInterval(() => {
    if (window.google?.accounts?.id) {
      clearInterval(interval);
      callback();
      return;
    }

    if (Date.now() - startedAt >= INIT_TIMEOUT_MS) {
      clearInterval(interval);
    }
  }, POLL_INTERVAL_MS);
}
